import React, { FunctionComponent } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

import { useGroupName } from "../../hooks/useGroupName";
import { useNullableDealerAccountInfo } from "../../stores/hooks/useNullableDealerAccountInfo";
import { useNullableNationalAccountInfo } from "../../stores/hooks/useNullableNationalAccountInfo";

export const Meta: FunctionComponent<{
  cmsTitle: null | string;
  title: string;
}> = ({ cmsTitle, title }) => {
  const dealerInfo = useNullableDealerAccountInfo();
  const nationalInfo = useNullableNationalAccountInfo();
  const groupName = useGroupName();
  const { t } = useTranslation();

  const value =
    cmsTitle ||
    [
      t(`aoda.pageTitle.${title}`),
      dealerInfo?.dealerName,
      nationalInfo?.nationalAccountName,
      groupName,
    ]
      .filter(Boolean)
      .slice(0, 2)
      .join(" | ");

  return (
    <Helmet>
      <title>{value}</title>
    </Helmet>
  );
};

/**
 * @see docs/worklog/TW-953-dealer-group-french-name/rfc.md
 * @see docs/worklog/TW-953-dealer-group-french-name/tfc.md
 */
